export default __webpack_public_path__ + "static/media/laxmanjhula.5cdf22d2.jpg";